import withErrorHandler from '../../../modules/error/ErrorHandlerWrapper';
import HelpBlock, { HelpBlockProps } from './HelpBlock';
import withInteractor from './HelpBlock.interactor';
import withPresenter from './HelpBlock.presenter';

export type { HelpBlockProps };
export default withInteractor(withPresenter(withErrorHandler(HelpBlock)));